import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Agreement } from 'cityads-v3/types/agreement';
import { SadukaResponseEntity } from 'cityads-v3/types/saduka';
import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const initialState = {
  isSaving: false,
  isSaved: false,
}

export const slice = createSlice({
  name: 'agreement',
  initialState,
  reducers: {
    updateAgreement: (state) => {
      state.isSaving = true
      state.isSaved = false
    },
    updateAgreementSuccess: (state, action: PayloadAction<SadukaResponseEntity<'agreement', Agreement>>) => {
      state.isSaving = false
      state.isSaved = true
    },
    updateAgreementFail: (state) => {
      state.isSaving = false
      state.isSaved = false
    },
  }
})

const {
  updateAgreement,
  updateAgreementSuccess,
  updateAgreementFail,
} = slice.actions

/**
 * Сохранение изменений по соглашению
 */
export function saveAgreement(agreement: Pick<Agreement, 'status' | 'id'>) {
  return makeRequest(`/saduka/agreements/${agreement.id}`, {
    types: [
      updateAgreement.type,
      updateAgreementSuccess.type,
      updateAgreementFail.type
    ],
    options: {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        agreement: {
          status: agreement.status
        }
      })
    }
  })
}

export default slice.reducer;
